const Vue = require('vue')
import Vuet from 'vuet'
import api from '@/util/api'
import config from '@/util/config'


import plugins from '@/util/vueplugins'
Vue.use(plugins)
Vue.use(Vuet)

import user from './user'
import order from './order'
import app from './app'
import workgroup from './workgroup'

var home = {
  data() {
    return {
      id: 0,
      managerGroup: {},
      ownerManagerGroup: {},
      committeeGroup: {},
      streetGroup: {},
      list: []
    }
  },
  fetch() {
    this.$api.menu.gethome().then((res) => {
      if (res.R) {
        var data = res.data;
        this.list = data.menus;
        if (data.managerGroup) {
          this.managerGroup = data.managerGroup
        }

        if (data.ownerManagerGroup) {
          this.ownerManagerGroup = data.ownerManagerGroup;
        }

        if (data.committeeGroup) {
          this.committeeGroup = data.committeeGroup;
        }

        if (data.streetGroup) {
          this.streetGroup = data.streetGroup;
        }
      }
    })
  }
}

var root = {
  data() {
    return {
      fetchlist: [],
      loaded: false, // 页面是否加载(网页第一打开标志 )
      showLogin: false,
      login_callback: null
    }
  },
  clear() {
    this.fetchlist = []
  },
  modules: {
    user,
    home,
    order,
    app,
    workgroup
  }
}

export default new Vuet({
  pathJoin: '/',
  modules: {
    root
  }
})
